import React from 'react'

const InspirationUniverseContext = React.createContext({})

export default function InspirationUniverseContainer ({
  children,
  restUrl,
  tagline,
  title,
  buttonText,
  image,
  video,
  noProductsText
}) {

  // generate a 6 digit number for wp_query random seed
  const generateUuid = () => {
    return Math.floor(Math.random() * 900000) + 100000
  }

  const [products, setProducts] = React.useState([])
  const [currentPage, setCurrentPage] = React.useState(1)
  const [totalPages, setTotalPages] = React.useState(1)
  const [uuid, setUuid] = React.useState(null)
  const [isLoading, setIsLoading] = React.useState(false)
  const [containerRef, setContainerRef] = React.useState(null)
  const [hasFetched, setHasFetched] = React.useState(false)

  return (
    <InspirationUniverseContext.Provider value={{
      restUrl,
      tagline,
      title,
      buttonText,
      image,
      video,
      noProductsText,
      products,
      setProducts,
      currentPage,
      setCurrentPage,
      totalPages,
      setTotalPages,
      uuid,
      setNewUuid: () => setUuid(generateUuid()),
      isLoading,
      setIsLoading,
      containerRef,
      setContainerRef,
      hasFetched,
      setHasFetched
    }}>
      {children}
    </InspirationUniverseContext.Provider>
  )
}

export { InspirationUniverseContext }
